import React, {Component} from 'react';
import ArticleTableCell from "./ArticleTableCell";

class ArticleTableRow extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let {
            RowName,
            Columns
        } = this.props.row;
        return (
            <tr>
                <td>
                    {RowName.Value}
                </td>
                {Columns.map((cell, index)=>{
                    return <ArticleTableCell cell={cell} text={this.props.text} key={index} index={index} />;
                })}
            </tr>
        )
    }
}

export default ArticleTableRow;